module.exports = __webpack_public_path__ + "media/images/covid/banner/sidebar/zh-hant-9dec3f5b3c1d7ebda4d2c923cd412338.jpg";